function parseInnerHTML(html, selector) {
  return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
}

function assemblageAddToCart() {

  let loadingMessage = document.getElementById('loading-message');
  loadingMessage.style.display = 'flex';

  let sectionSelectors = "cart-icon-bubble";
  let assemblage_dropdown = document.querySelector("#assemblage-quantity-dropdown");
  let assemblage_id = assemblage_dropdown.getAttribute('data-assemblage-id');
  let add_num = assemblage_dropdown.value;

  let addData = {
   'items': [{
    'id': assemblage_id,
    'quantity': add_num
    }],
    'sections': sectionSelectors
  };

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(addData)
  })
  .then((response) => response.json())
  .then((data) => {
    let updatedSections = data.sections;
    document.getElementById('cart-icon-bubble').innerHTML = parseInnerHTML(updatedSections["cart-icon-bubble"], "#shopify-section-cart-icon-bubble");
    setTimeout(function() {
      window.location.reload();
    }, 1500);
    return data;
  })
}